import { render } from "./Personal.vue?vue&type=template&id=54a556de"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__